import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { ColDef } from 'ag-grid-community';
import React, { useCallback, useRef } from 'react';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import { PackingStation, type PackingStationRelationsTabKey } from '../../models/PackingStation';

interface PackingStationsAgGridTableProps {
  packingStations: PackingStation[];
  isFetching?: boolean;
  selectedColumns?: string[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onOpenDetail?: (station: PackingStation, tab?: PackingStationRelationsTabKey) => void;
  onOpenEdit?: (station: PackingStation) => void;
  onPrint?: (station: PackingStation, size: 'small' | 'large') => void;
  refetch?: () => void;
}

export const PackingStationsAgGridTable = React.memo(function PackingStationsAgGridTable({
  packingStations,
  isFetching = false,
  selectedColumns = [],
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  onOpenDetail,
  onOpenEdit,
  onPrint,
  refetch,
}: PackingStationsAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);

  const handleGridReady = useCallback(() => {}, []);

  const { filteredColumnDefs } = useAgGridColumns({
    selectedColumns,
    onOpenDetail,
    onOpenEdit,
    onPrint,
    refetch,
  });

  const columnDefsWithRenderers: ColDef[] = filteredColumnDefs;

  return (
    <div className={`w-full ${isFetching && !isFetchingNextPage ? 'opacity-75' : ''}`}>
      <AgGridTable
        ref={agGridRef}
        data={packingStations}
        columnDefs={columnDefsWithRenderers}
        height="calc(100vh - 260px)"
        enableSelection={false}
        onGridReady={handleGridReady}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        gridOptions={{}}
      />
    </div>
  );
});
